import { render, staticRenderFns } from "./PromotersPage.vue?vue&type=template&id=27461d8a&scoped=true"
import script from "./PromotersPage.vue?vue&type=script&lang=js"
export * from "./PromotersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27461d8a",
  null
  
)

export default component.exports